import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

export const getCompanies = async (input = '', dealerId) => {
    try {
        const QUERY = `
            query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
                result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items { id name }
                }
            }
        `;
        let conditions = [];
        if (dealerId) conditions.push({ fields: ["dealerId"], terms: [String(dealerId)], exact: true });
        if (input) conditions.push({ fields: ["name"], terms: [input], exact: false });
        return await clientQuery(QUERY, {
            conditions,
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/dealers/views/.components/dealerAlertLogsTab/redux/saga', 'getCompanies');
    }
};

export const getDevices = async (input = '', companyId, dealerId) => {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items { id companyId label esn imei }
                }
            }
        `;
        let conditions = [];
        if (companyId) conditions.push({ fields: ["companyId"], terms: [companyId], exact: true });
        if (dealerId) conditions.push({ fields: ["company_dealerId"], terms: [String(dealerId)], exact: true });
        if (input) conditions.push({ fields: ["esn", "label", "imei"], terms: [input], exact: false });
        return await clientQuery(QUERY, { conditions, limit: 10, offset: 0 }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/dealers/views/.components/dealerAlertLogsTab/redux/saga', 'getDevices');
    }
};
